// extracted by mini-css-extract-plugin
module.exports = {"myInfoBtn":"Button_myInfoBtn__1rvHV","manualBtn":"Button_manualBtn__1VsE1"};